import React from 'react';
import { JoinRequestItem } from './join-request-item';
import { useTranslation } from 'react-i18next';
import { useClanControllerGetJoinRequestsQuery } from '@/store/services/MidleNestApi.service';

export default function GuildApplications() {
  const { t } = useTranslation();
  const { data } = useClanControllerGetJoinRequestsQuery({ page: 1, limit: 4 });

  return (
    <div className='flex w-full flex-col gap-y-8'>
      <h3 className='text-xl leading-7 font-medium'>{t('Applications')}</h3>
      <div className='overflow-y-auto max-h-none sm:max-h-[530px]'>
        <table className='w-full'>
          <thead>
            <tr>
              <th className='text-sm leading-5 font-medium'>{t('Player')}</th>
              <th className='text-sm leading-5 font-medium'>{t('Avg. Points per Day')}</th>
              <th className='text-sm leading-5 font-medium'>{t('Total Points')}</th>
              <th className='text-sm leading-5 font-medium' />
            </tr>
          </thead>
          <tbody>
            {data && data.list && data.list.map((i) => <JoinRequestItem key={i.id} {...i} />)}
          </tbody>
        </table>
      </div>
    </div>
  );
}
